import { getOneRule, updateRule } from '../../services/game.services.js';
import {
  FETCH_RULE_REQUEST,
  FETCH_RULE_SUCCESS,
  FETCH_RULE_FAILURE,
  UPDATE_RULE_REQUEST,
  UPDATE_RULE_SUCCESS,
  UPDATE_RULE_FAILURE,
} from './types';

export const fetchRule = (ruleId) => async (dispatch) => {
  try {
    dispatch({ type: FETCH_RULE_REQUEST });
    const response = await getOneRule(ruleId, JSON.parse(sessionStorage.getItem('myData')));
    dispatch({ type: FETCH_RULE_SUCCESS, payload: response.data });
  } catch (error) {
    dispatch({ type: FETCH_RULE_FAILURE, payload: error.message });
  }
};

export const updateRuleDetails = (ruleData) => async (dispatch) => {
  try {
    dispatch({ type: UPDATE_RULE_REQUEST });
    await updateRule(ruleData, JSON.parse(sessionStorage.getItem('myData')));
    dispatch({ type: UPDATE_RULE_SUCCESS, payload: ruleData });
  } catch (error) {
    dispatch({ type: UPDATE_RULE_FAILURE, payload: error.message });
  }
};